import { createContext, ReactNode, useMemo } from 'react'
import { IContinueLessons } from '@dtos/User'

interface IContinueLessonsContextData {
  continueLessons: IContinueLessons[] | null
  isLoading: boolean
}

export const ContinueLessonsContext =
  createContext<IContinueLessonsContextData>({} as IContinueLessonsContextData)

export function ContinueLessonsProvider({
  children,
  continueLessons,
  isLoading,
}: {
  children: ReactNode
  continueLessons: IContinueLessons[] | null
  isLoading: boolean
}) {
  const contextValue = useMemo(
    () => ({ continueLessons, isLoading }),
    [continueLessons, isLoading],
  )

  return (
    <ContinueLessonsContext.Provider value={contextValue}>
      {children}
    </ContinueLessonsContext.Provider>
  )
}
